module.exports = __webpack_public_path__ + "media/images/category-water-9fa19ca9c01e41c20952f3ef73326a52.jpg";